import { AppConstants } from "../../constants/AppConstants";
import { BulkUploadSheetComponent } from '../../component/bulkUploadSheetComponent/BulkUploadSheetComponent';

export const BulkUploadCreatorLeads = () => {
    return (
        <div className="adminContentSection">
            <BulkUploadSheetComponent heading="Bulk Upload Leads" uploadSheetAPI={AppConstants.uploadBulkLeadsAPI} downloadedSheetName={AppConstants.adminBulkUploadLeadsList} downloadTemplateAPI={AppConstants.downloadLeadTemplateAPI} multipartFileName="leadBulkUploadSheet" uploadFileLabel="Leads" />
        </div>
    )
};